export default __webpack_public_path__ + "static/media/Forside-mirror.40aceb74.jpg";